<template>
    <div class="index">
      <van-nav-bar :title="title"  v-if="isWx" left-arrow class="navBar" z-index="99"   @click-left="back"  />
      <div class="flex align-center py-1"   >
        <div class="flex-1"  >
          <van-tabs type="card"  v-model="queryParams.userType" @change="tabsChange" color="green" >
            <!--            <van-tab title="全部" :name="0" ></van-tab>-->
            <van-tab title="老师" :name="2">
            </van-tab>
            <van-tab title="学生" :name="3">
            </van-tab>
          </van-tabs>
        </div>
        <van-search v-model="queryParams.nickName" class="search flex-1"  shape="round" right-icon="search"   input-align="left" maxlength="40"  background=""
                    @input="SearchUser"
                    placeholder="姓名/账号/手机号/短号"  >
        </van-search>
      </div>


        <div class="hidden_over"  >
          <van-tabs type="card"  v-model="queryParams.userType"  @change="tabsChange" color="green" >
<!--            <van-tab title="全部" :name="0" ></van-tab>-->
            <van-tab title="老师" :name="2">
              <template #default>
                <user-module :query-params="queryParams" ref="user-module-teacher"  ></user-module>
              </template>
            </van-tab>
            <van-tab title="学生" :name="3">
              <template #default>
                <user-module :query-params="queryParams" ref="user-module-student"  ></user-module>
              </template>
            </van-tab>
          </van-tabs>
        </div>



<!--      <div>-->
<!--        <div v-show="queryParams.type==1">-->
<!--        &lt;!&ndash; 部门 &ndash;&gt;-->
<!--        <van-index-bar  :index-list="ABCList"  highlight-color="black"   z-index:999    >-->
<!--          <div v-for="(item,name) in list" :key="name" >-->
<!--            <van-index-anchor :index="name"   :scrollTo="name"    >-->
<!--              <div class="letterStyle"  >{{name}}</div>-->
<!--            </van-index-anchor>-->
<!--            <div class="Phonelist border-bottom " style=";padding:0px 16px" v-for="(val,index) in item" :key="index" @click="ToUser(val.userId)">-->
<!--              <headImage :data="val"   ></headImage>-->
<!--            </div>-->
<!--          </div>-->
<!--        </van-index-bar>-->
<!--        </div>-->
<!--        <van-divider v-if="noinfo" :style="{ color: '#009100', borderColor: '#009100', padding: '0 16px' }">{{finishedText}}  </van-divider>-->
<!--        <van-loading size="26px"  class="mt-3" type="circular" color="#028700" v-if="!listInfo"  vertical></van-loading>-->
<!--      </div>-->

    </div>
</template>

<script>
import {GetInfo,UserList,logout,logout_url} from'@/network/common'
import headImage from './components/headImage.vue'
import {debounce} from "@/assets/utils";
import UserModule from "@/views/home/components/userModule";
export default {
  name:'userList',
  data(){
    return{
      title:'',
      SearchValue:'',
      userInfo:'',//用户信息
      finishedText:'请您搜索进行查询',
      noinfo:false,
      indexList:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','#'],
      // 查询参数
      queryParams:{
        nickName:null,
        deptId:null,
        userType:2,
        type:1,
        // url:process.env.VUE_APP_BASE_API || '',
      },
      listInfo:null,//数据
      list: [],
      isWx:false,

    }
  },

  components:{UserModule, headImage},
  created(){
    if(this.$route.query.roles){
      this.roles=this.$route.query.roles
    }
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.isWx = true
    } else {
      this.isWx = false
    }
    if(this.$route.query.deptId){

      let row =this.$route.query
      // this.queryParams.userType=row.userType-0
      this.title=row.title
      if(row.searchText!=''){
        this.queryParams.nickName=row.searchText
      }
      this.queryParams.deptId=row.deptId

      // this.SearchUser()
    }

      // this.loading=false

      // this.SearchUser()
  },
  activated(){
    if(this.$route.query.roles){
      this.roles=this.$route.query.roles
    }
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.isWx = true
    } else {
      this.isWx = false
    }
    if(this.$route.query.deptId){

      let row =this.$route.query
      // this.queryParams.userType=row.userType-0
      this.title=row.title
      if(row.searchText!=''){
        this.queryParams.nickName=row.searchText
      }
      this.queryParams.deptId=row.deptId

      // this.SearchUser()
    }
    // this.SearchUser()
  },

  methods: {

    SearchUser: debounce(function (type) {

      if(this.queryParams.userType==2){
          this.$refs["user-module-teacher"].getList()
      }else {
          this.$refs["user-module-student"].getList()
      }
    }, 700, false),
// ********************



// ********************
   tabsChange(){
    // this.SearchUser()
     if(this.queryParams.userType==2){
       setTimeout(()=> {
         this.$refs["user-module-teacher"].getList()
       },500)
     }else {
       setTimeout(()=>{
         this.$refs["user-module-student"].getList()
       },500)

     }
    },

  back(){
     this.$router.back(-1)
  }


  },
  computed:{
    ABCList(){
      const abc = Object.keys(this.list);
      return abc
    },
    tabsName(){
      let name =''
      if(this.activeName==1){
           name ="个人"
      }else if(this.activeName==2){
          name ="班级"
      }else if(this.activeName == 3){
          name ="单位"
      }

      return name
    }
  }

}
</script>

<style>
    .index{font-size: 14.5px;}
    .navBar{
        background-color: rgb(0 145 0) ;
        color: white!important;;
    }
     .index .van-nav-bar .van-icon{
        color: white;
    }
    .index .van-nav-bar__title{color: white;}
    .index .van-nav-bar__text{color: white;}
    .index .van-search__content {background-color: rgb(245, 245, 245);}
    .hoverActive:hover{
      background-color: rgb(245, 245, 245);
    }
   .search .van-search__action{
      padding:0px
    }
    .index .van-index-bar__index{
      line-height:20px;
      font-size:13px
    }
    .index .Phonelist {line-height:25px !important}
    .letterStyle{
      background-color: rgb(241, 241, 241);
      font-size: 15px;
      font-weight: 600;
      text-align: left;
      padding:0px 0px  0px  15px;
      margin: 0px -16px 0px -16px;
    }
    .TSlabel{
      font-size: 13px;
      color: white;
      padding: 1px;
    }
    .hidden_over .van-tabs__wrap{
        overflow: hidden;
        position: absolute;
      opacity: 0;
      z-index: -11;
    }
</style>
